<template>
  <div style="margin: 0 72px;">
    <el-form ref="formRef" :model="petForm" label-width="70px" label-position="right">
      <el-form-item label="昵称：">
        <el-input v-model="petForm.name" placeholder="请输入宠物昵称" style="width: 22em" />
        <p style="color: red; font-size: 12px;">*信息将对客户可见，请谨慎填写</p>
      </el-form-item>
      <el-form-item label="品种：">
        <el-select v-model="breedId" placeholder="Select" style="width: 22em" @change="breedIdChange">
          <el-option v-for="item in breedIdArray" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="花色：">
        <el-select v-model="breedColorId" placeholder="Select" style="width: 22em">
          <el-option v-for="item in breedColorIdArray" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="毛长：">
        <el-radio-group v-model="woolState" style="margin-bottom: 4px;">
          <el-radio :label="1">短毛</el-radio>
          <el-radio :label="2">长毛</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="特征：">
        <el-input v-model="petForm.description" placeholder="请简单描述宠物的特征" style="width: 22em" />
      </el-form-item>
      <el-form-item label="性别：">
        <el-radio-group v-model="sex" style="margin-bottom: 4px;">
          <el-radio :label="1">弟弟</el-radio>
          <el-radio :label="2">妹妹</el-radio>
          <el-radio :label="0">未知</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="出生：">
        <div style="padding: 0.5em 1.5em 1em; background-color: #f6f6f6;width: 19em; border-radius: 4px;">
          <el-radio-group v-model="timeType">
            <el-radio :label="1">生日</el-radio>
            <el-radio :label="2">年龄</el-radio>
          </el-radio-group>
          <el-date-picker
              v-model="birthday"
              type="date"
              placeholder="请选择出生日期"
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              style="width: 100%"
              :disabled-date="disabledDate"
              v-if="timeType == 1"
          />
          <div style="display: flex;" v-if="timeType == 2">
            <el-select v-model="age" placeholder="Select" style="width: 6em">
              <el-option v-for="item in ageArray" :key="item" :label="item" :value="item">
              </el-option>
            </el-select>
            &nbsp;&nbsp;岁&nbsp;&nbsp;
            <el-select v-model="month" placeholder="Select" style="width: 6em">
              <el-option v-for="item in monthArray" :key="item" :label="item" :value="item">
              </el-option>
            </el-select>
            &nbsp;&nbsp;月
          </div>
        </div>
      </el-form-item>
      <el-form-item label="体重：" v-if="petForm.weight > 0">{{petForm.weight}}kg</el-form-item>
      <el-form-item label="绝育：">
        <el-radio-group v-model="neuteringState" style="margin-bottom: 4px;">
          <el-radio :label="1">已绝育</el-radio>
          <el-radio :label="2">未绝育</el-radio>
          <el-radio :label="0">未知</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="驱虫：">
        <div style="padding: 0.5em 1.5em 1em; background-color: #f6f6f6;width: 19em; border-radius: 4px;">
          <div style="margin-bottom: 0.5em">
            <p>内驱：</p>
            <el-date-picker
                v-model="petForm.inDriveDate"
                type="date"
                placeholder="最新内驱时间"
                format="YYYY-MM-DD"
                value-format="YYYY-MM-DD"
                style="width: 100%"
            />
          </div>
          <div>
            <p>外驱：</p>
            <el-date-picker
                v-model="petForm.outDriveDate"
                type="date"
                placeholder="最新外驱时间"
                format="YYYY-MM-DD"
                value-format="YYYY-MM-DD"
                style="width: 100%"
            />
          </div>
        </div>
      </el-form-item>
      <el-form-item label="首免：">
        <el-radio-group v-model="petForm.initialExemptionState" style="margin-bottom: 4px;" @change="initialExemptionStateChange">
          <el-radio :label="1">不全</el-radio>
          <el-radio :label="2">全</el-radio>
        </el-radio-group>
        <div v-if="petForm.initialExemptionState" style="padding: 1em 1.5em; background-color: #f6f6f6;width: 19em; border-radius: 4px;">
          <div style="display: flex; align-items: center; ">
            <p>第一针：</p>
            <el-radio-group v-model="petForm.oneExemptionState" @change="checkAll(1)">
              <el-radio :label="2">已打</el-radio>
              <el-radio :label="1">未打</el-radio>
            </el-radio-group>
          </div>
          <el-date-picker
              v-model="petForm.oneExemptionDate"
              type="date"
              placeholder="第一针的时间"
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              style="width: 100%"
              :disabled="petForm.oneExemptionState == 1"
          />
          <div style="display: flex; align-items: center;margin-top: 0.5em">
            <p>第二针：</p>
            <el-radio-group v-model="petForm.twoExemptionState" @change="checkAll(2)">
              <el-radio :label="2">已打</el-radio>
              <el-radio :label="1">未打</el-radio>
            </el-radio-group>
          </div>
          <el-date-picker
              v-model="petForm.twoExemptionDate"
              type="date"
              placeholder="第二针的时间"
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              style="width: 100%"
              :disabled="petForm.twoExemptionState == 1"
          />
          <div style="display: flex; align-items: center;margin-top: 0.5em">
            <p>第三针：</p>
            <el-radio-group v-model="petForm.threeExemptionState" @change="checkAll(3)">
              <el-radio :label="2">已打</el-radio>
              <el-radio :label="1">未打</el-radio>
            </el-radio-group>
          </div>
          <el-date-picker
              v-model="petForm.threeExemptionDate"
              type="date"
              placeholder="第三针的时间"
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              style="width: 100%"
              :disabled="petForm.threeExemptionState == 1"
          />
          <div style="display: flex; align-items: center;margin-top: 0.5em">
            <p>狂犬针：</p>
            <el-radio-group v-model="petForm.rabiesExemptionState" @change="checkAll(4)">
              <el-radio :label="2">已打</el-radio>
              <el-radio :label="1">未打</el-radio>
            </el-radio-group>
          </div>
          <el-date-picker
              v-model="petForm.rabiesExemptionDate"
              type="date"
              placeholder="狂犬针的时间"
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              style="width: 100%"
              :disabled="petForm.rabiesExemptionState == 1"
          />
        </div>
      </el-form-item>
      <el-form-item label="年免：">
        <div style="padding: 0.5em 1.5em 1em; background-color: #f6f6f6;width: 19em; border-radius: 4px;">
          <div style="margin-bottom: 0.5em">
            <p style="color: red; font-size: 12px;">*上一次完成首免或者年免的时间</p>
            <el-date-picker
                v-model="petForm.yearExemptionDate"
                type="date"
                placeholder="最新首免\年免时间"
                format="YYYY-MM-DD"
                value-format="YYYY-MM-DD"
                style="width: 100%"
                @change="checkInitialExemptionState"
            />
          </div>
        </div>
      </el-form-item>
    </el-form>
    <div class="dialog-footer" style="text-align: center; margin-bottom: 24px;">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit">确定</el-button>
    </div>
  </div>

</template>

<script>
import { postFormData, getFormData } from "@/api/api"
import { addOrUpdatePet, getAllPetBreedList, updatePetDel } from "@/api/url";

export default {
  name: "UserFromDialog",
  props: {
    value: Object
  },
  data() {
    return {
      petForm: this.value.petForm,
      idx: this.value.ids,
      userId: this.value.userId,
      timeType:1,

      breedIdArray: [],
      breedId: this.value.petForm.petBreedId,

      breedColorIdArray: [],
      breedColorId: this.value.petForm.petBreedColorId,

      birthday: this.value.petForm.birthday,
      ageArray: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
      age: this.value.petForm.petAgeMonth?this.value.petForm.petAgeMonth.age:0,
      monthArray: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
      month: this.value.petForm.petAgeMonth?this.value.petForm.petAgeMonth.month:0,

      sex: this.value.petForm.sex?this.value.petForm.sex:0,
      woolState: this.value.petForm.woolState?this.value.petForm.woolState:1,

      neuteringState: this.value.petForm.neuteringState?this.value.petForm.neuteringState:0,

    }
  },
  methods: {

    disabledDate(time) {
      return time.getTime() > Date.now()
    },

    breedIdChange(val) {
      this.breedColorIdArray = []
      for(let i=0; i<this.breedIdArray.length; i++) {
        if(val == this.breedIdArray[i].id) {
          this.breedColorIdArray = this.breedIdArray[i].petBreedColorList
          this.breedColorId = this.breedIdArray[i].petBreedColorList[0].id
        }
      }
    },

    checkInitialExemptionState() {
      if(this.petForm.initialExemptionState != 2) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '首免不全，无需填写年免时间',
          type: 'warning'
        });
        this.petForm.yearExemptionDate = ''
      }
    },

    initialExemptionStateChange() {
      if(this.petForm.initialExemptionState == 1) {
        this.petForm.yearExemptionDate = ''
      }
      if(this.petForm.initialExemptionState == 2) {
        this.petForm.oneExemptionState = 2
        this.petForm.twoExemptionState = 2
        this.petForm.threeExemptionState = 2
        this.petForm.rabiesExemptionState = 2
      }
    },

    checkAll(idx) {
      if(this.petForm.oneExemptionState == 2 && this.petForm.twoExemptionState == 2 && this.petForm.threeExemptionState == 2 && this.petForm.rabiesExemptionState == 2) {
        this.petForm.initialExemptionState = 2
      }else {
        this.petForm.initialExemptionState =1
      }
      switch (idx) {
        case 1:
          if(this.petForm.oneExemptionState == 1) {
            this.petForm.oneExemptionDate = ''
          }
          break;
        case 2:
          if(this.petForm.twoExemptionState == 1) {
            this.petForm.twoExemptionDate = ''
          }
          break;
        case 3:
          if(this.petForm.threeExemptionState == 1) {
            this.petForm.threeExemptionDate = ''
          }
          break;
        case 4:
          if(this.petForm.rabiesExemptionState == 1) {
            this.petForm.rabiesExemptionDate = ''
          }
          break;
      }
    },

    cancel() {
      this.$emit("close");
    },
    summit() {
      if(!this.petForm.name) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '昵称不能为空',
          type: 'warning'
        });
        return false
      }
      if(!this.breedId) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请选择品种',
          type: 'warning'
        });
        return false
      }
      if(!this.breedColorId) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请选择花色',
          type: 'warning'
        });
        return false
      }
      // if(!this.birthday && this.timeType == 1) {
      //   this.$message({
      //     showClose: true,
      //     duration: 2000,
      //     message: '出生时间不能为空',
      //     type: 'warning'
      //   });
      //   return false
      // }
      // if(this.age == 0 && this.month == 0 && this.timeType == 2) {
      //   this.$message({
      //     showClose: true,
      //     duration: 2000,
      //     message: '年龄不能为空',
      //     type: 'warning'
      //   });
      //   return false
      // }
      if(this.petForm.initialExemptionState == 1 && this.petForm.oneExemptionState == 2 && this.petForm.twoExemptionState == 2 && this.petForm.threeExemptionState == 2 && this.petForm.rabiesExemptionState == 2) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请修改首免状态',
          type: 'warning'
        });
        return false
      }
      let param = {}
      param['id'] = this.idx > -1?this.petForm.id:0;
      param['name'] = this.petForm.name;
      param['sex'] = this.sex;
      param['petBreedColorId'] = this.breedColorId;
      param['petBreedId'] = this.breedId;
      if(this.timeType == 1) {
        param['birthday'] = this.birthday;
      }else {
        param['age'] = this.age;
        param['month'] = this.month;
      }
      param['userId'] = this.userId;
      param['woolState'] = this.woolState;
      param['description'] = this.petForm.description;
      param['inDriveDate'] = this.petForm.inDriveDate;
      param['outDriveDate'] = this.petForm.outDriveDate;
      param['initialExemptionState'] = this.petForm.initialExemptionState;
      param['oneExemptionDate'] = this.petForm.oneExemptionDate;
      param['twoExemptionDate'] = this.petForm.twoExemptionDate;
      param['threeExemptionDate'] = this.petForm.threeExemptionDate;
      param['rabiesExemptionDate'] = this.petForm.rabiesExemptionDate;
      param['yearExemptionDate'] = this.petForm.yearExemptionDate;
      param['oneExemptionState'] = this.petForm.oneExemptionState;
      param['twoExemptionState'] = this.petForm.twoExemptionState;
      param['threeExemptionState'] = this.petForm.threeExemptionState;
      param['rabiesExemptionState'] = this.petForm.rabiesExemptionState;
      param['neuteringState'] = this.neuteringState;
      postFormData(addOrUpdatePet, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm', data.data)
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
      })
    },

    getAllPetList() {
      getFormData(getAllPetBreedList).then(data => {
        let {msg, code} = data
        if (code == 200) {
          this.breedIdArray = data.data.filter(item => item.type == 1)
          if(this.breedId) {
            for(let i=0; i<this.breedIdArray.length; i++) {
              if(this.breedId == this.breedIdArray[i].id) {
                this.breedColorIdArray = this.breedIdArray[i].petBreedColorList
              }
            }
          }else {
            this.breedColorIdArray = this.breedIdArray[0].petBreedColorList
            this.breedId = this.breedIdArray[0].id
            this.breedColorId = this.breedColorIdArray[0].id
          }
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
      })
    },




  },
  mounted() {
    this.getAllPetList()
  }
}
</script>

<style scoped>

</style>
